import { render, staticRenderFns } from "./appShop.vue?vue&type=template&id=3698acba&scoped=true"
import script from "./appShop.vue?vue&type=script&lang=js"
export * from "./appShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3698acba",
  null
  
)

export default component.exports